import { createAction } from '@reduxjs/toolkit';
export const retrieveWhatsNewItems = createAction('stylovyze/whatsNew/retrieveWhatsNewItems');
export const retrieveWhatsNewItemsResolved = createAction('stylovyze/whatsNew/retrieveWhatsNewItemsResolved');
export const fetchHTMLText = createAction('stylovyze/whatsNew/fetchHTMLText');
export const fetchHTMLTextResolved = createAction('stylovyze/whatsNew/fetchHTMLTextResolved');
export const setIFrameUrl = createAction('stylovyze/whatsNew/setIFrameUrl');
export const updateWhatsNewState = createAction('stylovyze/whatsNew/updateWhatsNewState');
export const updateLastSeenVersion = createAction('stylovyze/whatsNew/updateLastSeenVersion');
